import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GCaptchaComponent } from './g-captcha.component';
import { RecaptchaModule } from 'ng-recaptcha';



@NgModule({
  declarations: [
    GCaptchaComponent
  ],
  imports: [
    CommonModule,
    RecaptchaModule
  ],
  exports: [GCaptchaComponent]
})
export class GCaptchaModule { }
